export var Config = {
    DEBUG: false,
    LIB_VERSION: '2.77.0'
};

// Window global names for async modules
export var TARGETING_GLOBAL_NAME = '__mp_targeting';
export var RECORDER_GLOBAL_NAME = '__mp_recorder';

// Constants that are injected at build-time for the names of async modules.
export var RECORDER_FILENAME = '__MP_RECORDER_FILENAME__';
export var TARGETING_FILENAME = '__MP_TARGETING_FILENAME__';
